import { cva } from 'class-variance-authority'
import clsx from 'clsx'

const answerOptionVariants = cva(
  [
    'flex w-full items-center justify-center gap-2',
    'text-center bg-transparent border-2 transition-colors',
    'min-h-[var(--btn-h-md)] px-[var(--btn-px-md)] py-2.5 rounded-xl',
    'text-[length:var(--btn-fs-md)] font-[number:var(--btn-fw-md)]',
    'whitespace-normal break-words',
    'disabled:cursor-not-allowed'
  ],
  {
    variants: {
      // Estados de feedback (selected/correct/incorrect) mantêm a cor cheia mesmo
      // com o input travado — é o feedback do desafio. Só a opção neutra escurece
      // quando bloqueada, focando o olhar na resposta destacada.
      state: {
        default: 'border-gray-200 text-gray-800 disabled:opacity-60',
        selected: 'border-primary text-brand',
        correct: 'border-success text-brand',
        incorrect: 'border-danger text-brand'
      }
    },
    defaultVariants: {
      state: 'default'
    }
  }
)

export const AnswerOption = ({ state, className, ...rest }) => (
  <button
    type="button"
    className={clsx(answerOptionVariants({ state }), className)}
    {...rest}
  />
)

AnswerOption.displayName = 'AnswerOption'
